export function getMergeSortAnimations(array) {
    const animations = [];
    if (array.length <= 1) return array;
    const auxiliaryArray = array.slice();
    mergeSort(array, 0, array.length - 1, auxiliaryArray, animations);
    return animations;
}

function mergeSort(mainArray, startIdx, endIdx, auxiliaryArray, animations) {
    if (startIdx === endIdx)
        return;
    const middleIdx = Math.floor((startIdx + endIdx) / 2);
    mergeSort(auxiliaryArray, startIdx, middleIdx, mainArray, animations);
    mergeSort(auxiliaryArray, middleIdx + 1, endIdx, mainArray, animations);
    merge(mainArray, startIdx, middleIdx, endIdx, auxiliaryArray, animations);
}

function merge(mainArray, startIdx, middleIdx, endIdx, auxiliaryArray, animations) {
    let k = startIdx;
    let i = startIdx;
    let j = middleIdx + 1;
    while (i <= middleIdx && j <= endIdx) {
        // These are the values that we're comparing; we push them once to change their color.
        animations.push([i, j]);

        // These are the values hat we're comparing; we push them a second time to revert their color;
        animations.push([i, j]);

        if(auxiliaryArray[i] <= auxiliaryArray[j]) {
            // We overwrite the value at index k in the original array with the value at index i in the auxiliary array.
            animations.push([k, k]);
            animations.push([k, auxiliaryArray[i]]);
            animations.push([k, k]);
            mainArray[k++] = auxiliaryArray[i++];
        } else {
            // We overwrite the value at index k in the original array with the value at index j in the auxiliart array.
            animations.push([k, k]);
            animations.push([k, auxiliaryArray[j]]);
            animations.push([k, k]);
            mainArray[k++] = auxiliaryArray[j++];
        }
    }
    while (i <= middleIdx){
        animations.push([i, i]);
        animations.push([i, i]);
        animations.push([k, k]);
        animations.push([k, auxiliaryArray[i]]);
        animations.push([k, k]);
        mainArray[k++] = auxiliaryArray[i++];
    }
    while(j <= endIdx) {
        animations.push([j, j]);
        animations.push([j, j]);
        animations.push([k, k]);
        animations.push([k, auxiliaryArray[j]]);
        animations.push([k, k]);
        mainArray[k++] = auxiliaryArray[j++];
    }
}